<script lang="ts">
	export let up = false;
	export let circleFill = "#f66d6c";

</script>

<svg
	class:up
	xmlns="http://www.w3.org/2000/svg"
	width="100%"
	height="100%"
	viewBox="0 0 26 26">
	<g transform="translate(-854 -206)">
		<circle
			cx="13"
			cy="13"
			r="13"
			transform="rotate(180 440 116)"
			fill={circleFill} />
		<g>
			<g>
				<path
					d="M71.679 94.323a.425.425 0 0 1-.29-.112.385.385 0 0 1-.01-.563l8.365-8.248-8.365-8.253a.385.385 0 0 1 .01-.563.431.431 0 0 1 .59.01l8.645 8.53a.385.385 0 0 1 0 .553L71.979 94.2a.428.428 0 0 1-.3.123z"
					transform="rotate(90 403.569 548.827)"
					style="fill:#fff" />
			</g>
			<g>
				<path
					d="M63.349 98.728h-19.2a.418.418 0 0 1 0-.834h19.2a.418.418 0 0 1 0 .834z"
					transform="rotate(90 401.529 563.782)"
					style="fill:#fff" />
			</g>
		</g>
	</g>
</svg>

<style lang="scss">
	svg {
		overflow: visible;
		&.up {
			transform: rotate(180deg);
		}
	}

</style>
